module.exports = __webpack_public_path__ + "img/16.f63a3e4a.png";